type UseAdditionalInfoControlsArgs = {
  endorsementCount: number
  isError: boolean
  isPending: boolean
  isSubmitting: boolean
  isTrainingQuestionIncomplete: boolean
  onContinue: (shouldShowLaptopQuestion: boolean) => void
  onContinueWithoutEndorsements: (shouldShowLaptopQuestion: boolean) => void
  shouldShowLaptopQuestion: boolean
  validateTrainingQuestions: () => boolean
}

export function useAdditionalInfoControls({
  endorsementCount,
  isError,
  isPending,
  isSubmitting,
  isTrainingQuestionIncomplete,
  onContinue,
  onContinueWithoutEndorsements,
  shouldShowLaptopQuestion,
  validateTrainingQuestions
}: UseAdditionalInfoControlsArgs) {
  const handleContinue = () => {
    if (!validateTrainingQuestions()) {
      return
    }

    onContinue(shouldShowLaptopQuestion)
  }

  const handleContinueWithoutEndorsements = () => {
    if (!validateTrainingQuestions()) {
      return
    }

    onContinueWithoutEndorsements(shouldShowLaptopQuestion)
  }

  const isContinueDisabled =
    isPending || isError || isSubmitting || endorsementCount === 0 || isTrainingQuestionIncomplete
  const isContinueWithoutEndorsementsDisabled =
    isPending || isError || endorsementCount > 0 || isTrainingQuestionIncomplete

  return {
    handleContinue,
    handleContinueWithoutEndorsements,
    isContinueDisabled,
    isContinueWithoutEndorsementsDisabled
  }
}
